import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

interface PageTemplateProps {
  data: {
    page: {
      path?: string
      title?: string
      seo: any
      flexContent: any
    }
  }
  location?: any
  pageContext?: any
  prefix?: string
}

const PageTemplate: React.FC<PageTemplateProps> = ({
  data: {
    page: { flexContent, seo },
  },
  location = {},
  pageContext = {},
  prefix = 'Ontwerp_Flexcontent',
}) => (
  <Layout location={location}>
    <SEO seo={seo} />
    <FlexContentHandler
      prefix={prefix}
      fields={flexContent}
      location={location}
      pageContext={pageContext}
    />
  </Layout>
)

export const pageQuery = graphql`
  query ontwerpById($pageId: String!) {
    page: wpOntwerp(id: { eq: $pageId }) {
      ...generalOntwerpFragment
    }
  }
`

export default PageTemplate
